export default __webpack_public_path__ + "static/media/1067.79f8470d.png";